// Enhanced PageHero Component
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './PageHero.css';

export default function PageHero({ 
  eyebrow, 
  title, 
  subtitle, 
  bg, 
  overlay = 'light',
  breadcrumb,
  showDecor = true 
}) {
  return (
    <section className="page-hero" style={{ backgroundImage: `url(${bg})` }}>
      <div className={`page-hero__overlay page-hero__overlay--${overlay}`} />
      
      {/* Decorative Elements */}
      {showDecor && (
        <>
          <div className="page-hero__decor page-hero__decor--circle" />
          <div className="page-hero__decor page-hero__decor--circle2" />
          <div className="page-hero__decor page-hero__decor--line" />
        </>
      )}
      
      <div className="container page-hero__content">
        <motion.p 
          className="eyebrow" 
          initial={{ opacity: 0, y: 12 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.6 }}
        >
          {eyebrow}
        </motion.p>
        
        <motion.h1
          className={`page-hero__title ${overlay === 'dark' || overlay === 'colorful' ? 'page-hero__title--light' : ''}`}
          initial={{ opacity: 0, y: 26 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          {title}
        </motion.h1>
        
        {subtitle && (
          <motion.p
            className={`page-hero__subtitle ${overlay === 'dark' || overlay === 'colorful' ? 'page-hero__subtitle--light' : ''}`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            {subtitle}
          </motion.p>
        )}
        
        {/* Breadcrumb */}
        {breadcrumb && (
          <motion.div 
            className="page-hero__breadcrumb"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <Link to="/">Home</Link>
            <span className="separator">/</span>
            {breadcrumb.map((item, index) => (
              <span key={index}>
                {index === breadcrumb.length - 1 ? (
                  <span className="current">{item}</span>
                ) : (
                  <>
                    <Link to={item.path}>{item.label}</Link>
                    <span className="separator">/</span>
                  </>
                )}
              </span>
            ))}
          </motion.div>
        )}
      </div>
    </section>
  );
}